import { render, staticRenderFns } from "./ChannelDayClear.vue?vue&type=template&id=5905b7b4&"
import script from "./ChannelDayClear.vue?vue&type=script&lang=ts&"
export * from "./ChannelDayClear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelDayClear.vue"
export default component.exports